import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import React, { FunctionComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import messages from '../intl/messages';
import { spacings } from './lab/spacings';
import { SectionHeader } from './lab/TextGroup/SectionHeader';
import { SegmentGroups } from './SegmentGroups';
import { SaviIntlGroups } from './SaviIntlGroups';

interface OwnProps {
  isSaviSelectIntl: boolean;
}

interface ItineraryOptionsProps
  extends OwnProps,
    WithStyles<typeof styles>,
    InjectedIntlProps {}

const ItineraryOptionsBase: FunctionComponent<ItineraryOptionsProps> = (
  props: ItineraryOptionsProps,
) => {
  const {
    intl: { formatMessage },
    isSaviSelectIntl,
  } = props;
  return (
    <>
      <SectionHeader>
        {formatMessage(messages.common.itineraryOptions)}
      </SectionHeader>
      {isSaviSelectIntl ? < SaviIntlGroups /> : <SegmentGroups />}
    </>
  );
};

// styled
const styles = (theme: Theme) => {
  const {
    between: {
      card: { header: cardHeaderSpacing },
    },
  } = spacings(theme);

  return createStyles({
    segments: {
      ...cardHeaderSpacing,
    },
  });
};

const enhance = compose<ItineraryOptionsProps, OwnProps>(
  pure,
  withStyles(styles),
  injectIntl,
);

/**
 * Header and container for all the segment groups
 */
export const ItineraryOptions = enhance(ItineraryOptionsBase);

ItineraryOptions.displayName = 'ItineraryOptions';
